import WebMap from '@arcgis/core/WebMap';
import MapView from '@arcgis/core/views/MapView';


export const initMap = (webmapId) => {
  console.log(`Loading webmap: ${webmapId}`);
  const webmap = new WebMap({
    portalItem: {
      id: webmapId,
    },
  });

  return webmap;
};

export const initView = (webmap, mapRef) => {
  const view = new MapView({
    map: webmap,
    container: mapRef.current,
    constraints: {
      rotationEnabled: true,
    },
  });

  view.ui.remove('zoom');

  return { view, widgets: {  } };
};
